module.exports = __webpack_public_path__ + "static/img/secllie2.24813b9.png";


//////////////////
// WEBPACK FOOTER
// ./static/secllie2.png
// module id = v1sI
// module chunks = 1